import { useState } from "react";
import { api } from "../api.ts";

export function CreateOrgForm({ onCreated }: { onCreated: (slug: string) => void }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const org = await api.createOrganization(name.trim());
      setName("");
      onCreated(org.slug);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="select-create-form">
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="New organization name"
        maxLength={120}
        autoFocus
      />
      {error && <p className="select-create-error">{error}</p>}
      <button type="submit" disabled={busy || name.trim().length < 2}>
        {busy ? "Creating…" : "Create organization"}
      </button>
    </form>
  );
}
